import React, { useEffect, useState } from "react";
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import AboutUsNumbers from '../component/AboutUsNumbers'
import AndThenThere from '../component/AndThenThere' 
import TheReality from '../component/TheReality' 
import HomeGreatFullLife from '../component/HomeGreatFullLife' 
import HomeCareers from '../component/HomeCareers'
import AboutCompany from '../component/AboutCompany'
import Footer from '../component/Footer'
import '../scss/about-us.scss'
import '../scss/sub-banner.scss'


import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

function About() {

  const [pageData, setPageData] = useState(null);
  const { pageResponse } = useSelector((state) => state.visitor);


  useEffect(() => {
    if (pageResponse) {
      let pageContent = pageResponse.find((r) => r.code === "about-us");
      setPageData(pageContent.about_us_section);
    }
  }, [pageResponse]);

  return (
    <>
      <Helmet>
        <title>About Us | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>

      <main className='main home-page'>
        <Header />   
        <SubBanner HeaderTitle="About Us" />     
        <AboutUsNumbers data={pageData?.section_1} />  
        <AboutCompany data={pageData?.section_2} />
        <TheReality data={pageData?.section_3} />
        <AndThenThere data={pageData?.section_4} />  
        <HomeGreatFullLife data={pageData?.section_5} /> 
        <HomeCareers data={pageData?.section_5} /> 
      </main>
      <Footer />
    </>
  )
}
export default About 


